import {http} from '@/http'

export default {
  // --- Países ---
  listCountries() {
    return http.get('/api/v1/countries')
  },
  getCountry(id) {
    return http.get(`/api/v1/countries/${id}`)
  },
  createCountry(data) {
    return http.post('/api/v1/countries', data)
  },
  updateCountry(id, data) {
    return http.put(`/api/v1/countries/${id}`, data)
  },

  // --- Ciudades ---
  listCities() {
    return http.get('/api/v1/cities')
  },
  getCity(id) {
    return http.get(`/api/v1/cities/${id}`)
  },
  createCity(data) {
    return http.post('/api/v1/cities', data)
  },
  updateCity(id, data) {
    return http.put(`/api/v1/cities/${id}`, data)
  },

  // --- Aeropuertos ---
  listAirports() {
    return http.get('/api/v1/airports')
  },
  getAirport(id) {
    return http.get(`/api/v1/airports/${id}`)
  },
  createAirport(data) {
    return http.post('/api/v1/airports', data)
  },
  updateAirport(id, data) {
    return http.put(`/api/v1/airports/${id}`, data)
  },

  // --- Distritos (público). cityId opcional filtra por ciudad; sin él, Lima. ---
  listDistricts(cityId) {
    return http.get('/api/v1/public/districts', {
      params: cityId ? { city_id: cityId } : {}
    })
  }
}
